import { render, staticRenderFns } from "./title_area.vue?vue&type=template&id=357b45c4&"
import script from "./title_area.vue?vue&type=script&lang=js&"
export * from "./title_area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports